__turbopack_context__.v({
  "brand": "Login-module__t61pwq__brand",
  "brandMark": "Login-module__t61pwq__brandMark",
  "brandName": "Login-module__t61pwq__brandName",
  "button": "Login-module__t61pwq__button",
  "card": "Login-module__t61pwq__card",
  "error": "Login-module__t61pwq__error",
  "field": "Login-module__t61pwq__field",
  "form": "Login-module__t61pwq__form",
  "input": "Login-module__t61pwq__input",
  "label": "Login-module__t61pwq__label",
  "page": "Login-module__t61pwq__page",
  "title": "Login-module__t61pwq__title",
});
